import React from 'react'
import { Link } from 'react-router-dom'
import wad from '../../../../assets/img/ecd_mn.webp'
import './Wadhead.css'

function Wadhead() {
  return (
    <section className='hmslder-sec serhead-sec'>
        <div className='breadcrumbs'>
            <div className='container'>
             <ul>
               <li><Link to='/'>Home</Link></li> 
               <li><Link to='/Service'>Services</Link></li>  
               <li>E-Commerce Development</li>   
             </ul> 
             </div> 
        </div>
        <div className='container'>
           <div className='hmslder-txt'>
              <h2>Build an online store that sells and scales - <span>Creating commerce experiences that</span> convert visitors into loyal customers </h2>
              <p>360 Bytes builds e-commerce platforms that combine beautiful storefront design with robust backend architecture. Whether you need a single product shop or a complex marketplace, we deliver secure, fast, and conversion-optimised solutions.</p>
            </div> 
           <div className='hmslder-img'>
            <img src={wad} alt='E-Commerce Development' width={1200} height={800} loading="lazy" />
            </div>  
        </div>
    </section>
  )
}

export default Wadhead
